module.exports = __webpack_public_path__ + "static/media/megumin-icon.300e629c.png";